import React from 'react'
import "../../../node_modules/easy-pie-chart/dist/jquery.easypiechart";

export interface ISystemPatientTile  {
    label: string,
    max: number,
    value: number,
    previousValue: number,
    iconName: string,
    
}


export const SystemPatientTile = (props: ISystemPatientTile) => {
    //var element = document.querySelector('.chart');
    //var chart = new EasyPieChart(element, {
    //    // your options goes here
    //    lineWidth: 10,
    //    barColor: "#004269",
    //    trackColor: "#f6f8fb"
    //});

    
    var currentPercentage = (props.value / props.max) * 100;
    var lastPercentage = (props.previousValue / props.max) * 100;
    var compare = (currentPercentage == lastPercentage
        ? "No Change"
        : (currentPercentage < lastPercentage
            ? (<><span className="icon-graph_down status-down"></span> {Math.floor(currentPercentage - lastPercentage)}% less than last month.</>)
            : (<><span className="icon-graph_up status-up"></span> {Math.floor(currentPercentage - lastPercentage)}% more than last month.</>)
        ))

    return <div className="tiles tiles-featured">
            <h3>{props.label}</h3>
            <div className="tiles-featured-info">
            <span className={props.iconName}></span>
                <span className="easy-pie-chart"
                    data-percent={currentPercentage.toFixed()}
                    data-options="{lineWidth: 10, barColor: #004269,trackColor:#f6f8fb}">
                    <span className="percent s-18">{props.max}/{props.value}</span>
                    <canvas height="110" width="110"></canvas></span></div>
            <p className="mt-4 mb-0 text-muted">{compare}</p>
        </div>
   

}
